import axios from 'axios';
import { UserDto } from './usersService';

export type Secretary = UserDto;

export interface AssignSecretaryRequestDto {
  secretaryId: number;
}

/** ליד המשויך למזכירה — לתצוגה במודאל המזכירה (כיוון מזכירה-מרכזי) */
export interface SecretaryAssignedLead {
  id: number;
  fullName: string;
  phone?: string;
  statusName?: string;
}

/** לקוח המשויך למזכירה — לתצוגה במודאל המזכירה (כיוון מזכירה-מרכזי) */
export interface SecretaryAssignedClient {
  id: number;
  fullName: string;
  idNumber?: string;
  phone?: string;
  statusName?: string;
}

export const secretariesApi = {
  search: async (search?: string): Promise<Secretary[]> => {
    const params = new URLSearchParams();
    if (search && search.trim()) {
      params.append('search', search.trim());
    }
    const url = params.toString() ? `/users/secretaries?${params.toString()}` : '/users/secretaries';
    const response = await axios.get(url);
    return response.data;
  },

  getAll: async (): Promise<Secretary[]> => {
    const response = await axios.get('/users/secretaries');
    return response.data;
  },

  getByLead: async (leadId: number): Promise<Secretary[]> => {
    const response = await axios.get(`/secretaries/leads/${leadId}`);
    return response.data;
  },

  getByClient: async (clientId: number): Promise<Secretary[]> => {
    const response = await axios.get(`/secretaries/clients/${clientId}`);
    return response.data;
  },

  assignToLead: async (leadId: number, secretaryId: number): Promise<void> => {
    await axios.post(`/secretaries/leads/${leadId}/assign`, { secretaryId });
  },

  removeFromLead: async (leadId: number, secretaryId: number): Promise<void> => {
    await axios.delete(`/secretaries/leads/${leadId}/${secretaryId}`);
  },

  assignAllToLead: async (leadId: number): Promise<{ added: number }> => {
    const response = await axios.post(`/secretaries/leads/${leadId}/assign-all`);
    return response.data;
  },

  assignToClient: async (clientId: number, secretaryId: number): Promise<void> => {
    await axios.post(`/secretaries/clients/${clientId}/assign`, { secretaryId });
  },

  removeFromClient: async (clientId: number, secretaryId: number): Promise<void> => {
    await axios.delete(`/secretaries/clients/${clientId}/${secretaryId}`);
  },

  assignAllToClient: async (clientId: number): Promise<{ added: number }> => {
    const response = await axios.post(`/secretaries/clients/${clientId}/assign-all`);
    return response.data;
  },

  // --- כיוון מזכירה-מרכזי: שליפת הלידים/לקוחות המשויכים למזכירה נתונה (מנהל מערכת) ---

  getLeadsBySecretary: async (secretaryId: number): Promise<SecretaryAssignedLead[]> => {
    const response = await axios.get(`/secretaries/${secretaryId}/leads`);
    return response.data;
  },

  getClientsBySecretary: async (secretaryId: number): Promise<SecretaryAssignedClient[]> => {
    const response = await axios.get(`/secretaries/${secretaryId}/clients`);
    return response.data;
  },
};
